module.exports = __webpack_public_path__ + "img/26.d4ac8131.jpg";